export const EXECUTIVE_REQUISITION = "EXECUTIVE_REQUISITION";
